
import { faBuildingUser, faDiceD6, faHospitalAlt, faHospitals, faKitMedical, faUserMd, faBookMedical  } from "@fortawesome/pro-duotone-svg-icons";
import MedicGuideButton from "./MedicGuideButton";
import { faStar } from "@fortawesome/free-solid-svg-icons";

function MedicGuideButtons() {
    return (
        <div className="medic-guide-button-options" role="group" aria-label="Opções de navegação do Guia Médico grupo de botões 8 itens">
            <div className="medic-guide-responsive-favorite-button">
                <MedicGuideButton icon={faStar} to="/guiaMedico/favoritos" name="Favoritos"/>
            </div>
            <div className="medic-guide-buttons-holder">
                <div className="medic-guide-grid-favorite-button">
                    <MedicGuideButton icon={faStar} to="/guiaMedico/favoritos" name="Favoritos"/>
                </div>
                <MedicGuideButton icon={faUserMd} to="/guiaMedico/medicos" name="Médicos"/>
                <MedicGuideButton icon={faHospitalAlt} to="/guiaMedico/hospitais" name="Hospitais"/>
                <MedicGuideButton icon={faHospitals} to="/guiaMedico/clinicas" name="Clínicas"/>
                <MedicGuideButton icon={faBuildingUser} to="/guiaMedico/centrosDiagnostico" name="Centro de diagnósticos"/>
                <MedicGuideButton icon={faDiceD6} to="/guiaMedico/laboratorios" name="Laboratórios"/>
                <MedicGuideButton icon={faKitMedical} to="/guiaMedico/outros" name="Profissionais de Saúde"/>
                <MedicGuideButton icon={faBookMedical} to="https://www.unimed.coop.br/site/guia-medico#/" name="Guia Nacional Unimed"/>
            </div>
        </div>
    );
}

export default MedicGuideButtons;